import { Language } from '@/types/i18n';

/**
 * Utility functions for internationalization
 */

/**
 * Validates if a language code is supported
 */
export function isValidLanguage(lang: string): lang is Language {
  return lang === 'en' || lang === 'fr';
}

/**
 * Gets the default language
 */
export function getDefaultLanguage(): Language {
  return 'en';
}

/**
 * Gets all supported languages
 */
export function getSupportedLanguages(): Language[] {
  return ['en', 'fr'];
}

/**
 * Gets language display names
 */
export function getLanguageDisplayNames(): Record<Language, string> {
  return {
    en: 'English',
    fr: 'Français',
  };
}

/**
 * Gets language native names
 */
export function getLanguageNativeNames(): Record<Language, string> {
  return {
    en: 'English',
    fr: 'Français',
  };
}

/**
 * Detects browser language preference
 */
export function detectBrowserLanguage(): Language {
  if (typeof window === 'undefined') {
    return getDefaultLanguage();
  }

  const browserLang = navigator.language.split('-')[0];
  return isValidLanguage(browserLang) ? browserLang : getDefaultLanguage();
}

/**
 * Storage keys for persistence
 */
export const STORAGE_KEYS = {
  LANGUAGE_PREFERENCE: 'sicio-language-preference',
  FIRST_VISIT: 'sicio-first-visit',
  DASHBOARD_LANGUAGE: 'sicio-dashboard-language',
} as const;